import { Component , Input} from "@angular/core";
import {CustomColumnComponent} from "@bb-vendure/admin-ui/core"
@Component({
   selector: 'artist-name-cell', 
   template: `
   <div>{{artistName}}</div>
   `,
   standalone: true,
})
export class ArtistNameCell implements CustomColumnComponent {
    @Input() rowItem: { customFields: {artistName:string} };

    artistName: string
    
    async ngOnInit() {
        this.artistName = this.rowItem.customFields.artistName ?? "*"
    }
}